module.exports = __webpack_public_path__ + "img/dispatch-p2.cef09c29.jpg";